import debug from 'bows';
import loader from './util/_loader';
import unserialize from './util/_unserialize';

const log = debug('search-filters');

class SearchFilter {
	constructor(node, api = '/wp-json/') {
		this.node = node;
		this.api = `${api}playworks/search`;
		this.form = this.node.querySelector('.search-filters__form');
		this.input = this.form.querySelector('.search-filters__input');
		this.results = this.node.querySelector('.search-filters__results');
		this.title = this.node.querySelector('.search-filters__title');
		this.autoload = this.form.dataset.autoload == 1;
		this.orderby = (this.form.orderby) ? this.form.orderby.value : '';
		this.order = (this.form.order) ? this.form.order.value : 'DESC';
		this.handlingPopState = false;

		// create out spinning loading icon
		this.loader = document.createElement('div');
		this.loader.classList.add('game__loader');
		this.loader.innerHTML = loader;

		// default query parameters
		this.params = '';
		this.defaultQuery = {
			page: 1,
			per_page: 9,
			search: (this.input ? encodeURIComponent(this.input.value) : ''),
			orderby: this.orderby,
			order: this.order,
		}
		// pass special multisite value from form field
		if (this.form.multisite && this.form.multisite.value) {
			this.defaultQuery.multisite = true;
		}
		if (this.form.post_type && this.form.post_type.value) {
			this.defaultQuery.post_type = this.form.post_type.value;
		}

		this.query = {};
		for (let key in this.defaultQuery) {
			if (this.defaultQuery.hasOwnProperty(key)) {
				this.query[key] = this.defaultQuery[key];
			}
		}

		// set default values based on url parameters
		if (location.search) {
			const queryParams = unserialize(decodeURIComponent(location.search));
			if (queryParams) {
				for (let param in queryParams) {
					if (queryParams.hasOwnProperty(param)) {
						this.query[param] = queryParams[param];
					}
				}
			}
		}

		// create pagination blocks
		this._pagination = this.node.querySelector('.search-filters__pagination');

		// event delegation on pagination
		this._pagination.addEventListener('click', (e) => {
			let node = e.target;
			while (!node.matches('a')) {
				if (node === this._pagination) {
					e.stopPropagation();
					return;
				}
				node = node.parentNode;
			}

			if (node.matches('.pagination__next')) {
				e.preventDefault();
				this.query.page++;
				this.load();
			} else if (node.matches('.pagination__prev')) {
				e.preventDefault();
				this.query.page--;
				this.load();
			} else if (node.dataset.page) {
				e.preventDefault();
				this.query.page = parseInt(node.dataset.page, 10);
				this.load();
			}
		});

		this._paginationPrev = this.node.querySelector('.pagination__prev');
		if (!this._paginationPrev) {
			this._paginationPrev = document.createElement('a');
			this._paginationPrev.classList.add('pagination__prev');
			this._paginationPrev.appendChild(document.createTextNode('Previous'));
			this._pagination.appendChild(this._paginationPrev);
		} else {
			this._paginationPrev.removeAttribute('href');
		}

		this._paginationNext = this.node.querySelector('.pagination__next');
		if (!this._paginationNext) {
			this._paginationNext = document.createElement('a');
			this._paginationNext.classList.add('pagination__next');
			this._paginationNext.appendChild(document.createTextNode('Next'));
			this._pagination.appendChild(this._paginationNext);
		} else {
			this._paginationNext.removeAttribute('href');
		}

		this._paginationNumbers = Array.from(this.node.querySelectorAll('.page-numbers'));
		this._paginationNumbers.forEach((node) => {
			node.dataset.page = parseInt(node.textContent);
		});

		// Leaving in case they want literally "First" and "Last"
		// Chosen solution was to add this to pagination links instead

		// add first and last links
		// this._paginationFirst = this.node.querySelector('.pagination__first');
		// if (!this._paginationFirst) {
		// 	this._paginationFirst = document.createElement('a');
		// 	this._paginationFirst.classList.add('pagination__first');
		// 	this._paginationFirst.appendChild(document.createTextNode('First'));
		// 	this._pagination.appendChild(this._paginationFirst);
		// } else {
		// 	this._paginationFirst.removeAttribute('href');
		// }

		// this._paginationLast = this.node.querySelector('.pagination__last');
		// if (!this._paginationLast) {
		// 	this._paginationLast = document.createElement('a');
		// 	this._paginationLast.classList.add('pagination__last');
		// 	this._paginationLast.appendChild(document.createTextNode('Last'));
		// 	this._pagination.appendChild(this._paginationLast);
		// } else {
		// 	this._paginationLast.removeAttribute('href');
		// }

		// submit form on enter
		this.form.addEventListener('submit', (e) => {
			e.preventDefault();
			if (this.input) {
				this.query.search = this.input.value;
			}
			this.query.page = 1;
			this.load();
		});

		this.selectrs = Array.from(this.form.querySelectorAll('.search-filters__select')).map((select) => {
			// grab taxonomy data from the select node itself
			const taxonomy = select.dataset.taxonomy;

			// initilize selectr elements
			const selectr = new Selectr(select, {
				placeholder: select.placeholder,
				defaultSelected: false,
				allowDeselect: true,
				searchable: false,
				multiple: true,
				renderOption: (option) => {
					// render our faux checkbox
					return `<span class="selectr-checkbox"></span>${option.textContent}`;
				}
			});

			// set selectr value if query string values were provided
			selectr.on('selectr.init', () => {
				if (taxonomy && this.query[taxonomy]) {
					selectr.setValue(this.query[taxonomy]);
				} else {
					selectr.clear();
				}
			});

			// submit our form when values change
			selectr.on('selectr.change', (option) => {
				if (this.handlingPopState) {
					return;
				}

				const value = selectr.serialize().filter((val) => val.selected).map((val) => val.value);
				if (value.length) {
					this.query[taxonomy] = value;
				} else if (this.query[taxonomy]) {
					delete this.query[taxonomy]; // don't pass any empty array
				}

				this.query.page = 1;

				this.load();
			});

			return selectr;
		});

		// handle back button
		window.addEventListener('popstate', (e) => {
			this.query = (e.state && e.state.query) ? e.state.query : this.defaultQuery;
			// archives without a keyword box (testimonials) have no input
			if (this.input) {
				this.input.value = decodeURIComponent(this.query.search);
			}
			log(this.selectrs, this.query);

			this.handlingPopState = true;

			this.selectrs.forEach((selectr) => {
				// log(selectr.el.dataset.taxonomy);
				if (this.query[selectr.el.dataset.taxonomy]) {
					// only set the different values beacuse selectr toggles all values sent whether already checked or not
					selectr.setValue(selectr.getValue().filter((val) => this.query[selectr.el.dataset.taxonomy].indexOf(val) === -1));
				} else {
					selectr.clear();
				}
			});
			this.load(false);

			this.handlingPopState = false;
		});

		if (this.autoload) {
			// load initial query without the history api push
			this.load(false);
		} else {
			// results are server rendered, so only fetch the facet counts
			this.loadFacets();
		}
	}

	facetParams() {
		// ask the api for result counts per term for every taxonomy dropdown
		return this.selectrs
			.map((selectr) => selectr.el.dataset.taxonomy)
			.filter(Boolean)
			.map((taxonomy) => `facets[]=${encodeURIComponent(taxonomy)}`)
			.join('&');
	}

	loadFacets() {
		const facets = this.facetParams();
		if (!facets) {
			return;
		}

		const xhr = new XMLHttpRequest();
		xhr.open('GET', `${this.api}?${this.getParams()}&per_page=1&${facets}`);
		xhr.addEventListener('load', () => {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				this.applyFacets(response && response.facets);
			}
		});
		xhr.send();
	}

	applyFacets(facets) {
		// null when search fell back to the database; leave the dropdowns as they are
		if (!facets) {
			return;
		}

		this.selectrs.forEach((selectr) => {
			const counts = facets[selectr.el.dataset.taxonomy];
			if (!counts) {
				return;
			}

			selectr.options.forEach((option, i) => {
				const item = selectr.items[i];
				if (!item) {
					return;
				}

				if (!option.dataset.label) {
					option.dataset.label = option.textContent.trim();
				}

				const count = counts[option.value] || 0;
				option.textContent = count ? `${option.dataset.label} (${count})` : option.dataset.label;
				item.innerHTML = `<span class="selectr-checkbox"></span>${option.textContent}`;

				// hide options with no matches, but never one the visitor already picked;
				// inline style because selectr resets its own "excluded" class on open
				item.style.display = (count || option.selected) ? '' : 'none';
			});
		});
	}

	getParams() {
		// create an array compatible query string from this.query values
		this.params = '';

		if (typeof this.query.search === 'string' && this.query.search.length) {
			this.query.orderby = '';
		} else {
			this.query.orderby = this.orderby;
		}

		for (let key in this.query) {
			if (this.query.hasOwnProperty(key) && this.query[key]) {
				log(key, this.query[key]);
				if (Array.isArray(this.query[key])) {
					this.query[key].forEach((val) => {
						this.params += `&${key}[]=${encodeURIComponent(val)}`;
					});
				} else {
					this.params += `&${key}=${encodeURIComponent(this.query[key])}`;
				}
			}
		}

		// make sure we dont start with a ? or &
		this.params = this.params.replace(/^[?&]/, '');

		log('params', this.params);
		return this.params;
	}

	load(history = true) {
		// build query string from params
		this.getParams();

		// is not the first load, lets push it onto the history api
		log('history', history);
		if (history) {
			window.history.pushState({ query: this.query }, null, `${location.origin}${location.pathname}?${this.params}`);

			if (this.title) {
				this.title.hidden = true;
			}
		}

		// abort a current xhr if a new filter has been applied
		if (this.xhr instanceof XMLHttpRequest) {
			this.xhr.abort();
		}

		// hide pagination while loading
		this._pagination.hidden = true;

		// empty our current results
		Array.from(this.results.children).forEach((card) => {
			card.parentNode.removeChild(card);
		});

		// create our request
		this.xhr = new XMLHttpRequest();
		const facets = this.facetParams();
		this.xhr.open('GET', `${this.api}?${this.params}${facets ? `&${facets}` : ''}`);

		// hide featured text
		if (this.featuredIntro && this.featuredIntro.parentNode) {
			this.featuredIntro.parentNode.removeChild(this.featuredIntro);
		}

		// show loading icon
		this.results.appendChild(this.loader);

		// callback for our xhr
		this.xhr.addEventListener('load', () => {
			log('loaded', this.xhr.status, this.xhr.responseText);
			// remove loading icon
			this.loader.parentNode.removeChild(this.loader);

			if (this.xhr.status === 200) {
				const data = JSON.parse(this.xhr.responseText);

				// facet requests return { items, facets }; plain requests return the items array
				const response = Array.isArray(data) ? data : (data.items || []);
				if (!Array.isArray(data)) {
					this.applyFacets(data.facets);
				}

				if (response && !response.length) {
					// no results to be shown
					this.results.insertAdjacentHTML('beforeend', '<p class="search-filters__no-results">No items match your filters</p>');
					return;
				}

				// append card html to our results
				response.forEach((r) => {
					this.results.insertAdjacentHTML('beforeend', r.card);
				});

				// create pagination based on the X-WP-TotalPages header
				this.buildPagination(parseInt(this.xhr.getResponseHeader('X-WP-TotalPages'), 10));
			} else {
				this.results.insertAdjacentHTML('beforeend', '<p class="search-filters__no-results">There was an error processing your request. Please try again later.</p>');
			}

			// remove our request object
			delete this.xhr;
		});

		// ahoy
		this.xhr.send();
	}

	buildPagination(totalPages) {
		// remove dots
		this._paginationDots = Array.from(this.node.querySelectorAll('.dots'));

		while (this._paginationDots.length) {
			let dots = this._paginationDots.pop();
			dots.parentNode.removeChild(dots);
		}

		// remove our page numbers
		while (this._paginationNumbers.length) {
			let num = this._paginationNumbers.pop();
			num.parentNode.removeChild(num);
		}

		if (typeof this.query.page === 'string') {
			this.query.page = parseInt(this.query.page, 10);
		}

		log(this.query.page, totalPages);

		// disable or enable previous link
		if (this.query.page === 1) {
			this._paginationPrev.classList.add('pagination__prev--disabled');
		} else {
			this._paginationPrev.classList.remove('pagination__prev--disabled');
		}

		// disable or enable next link
		if (this.query.page === totalPages) {
			this._paginationNext.classList.add('pagination__next--disabled');
		} else {
			this._paginationNext.classList.remove('pagination__next--disabled');
		}

		// sub-routine to create a page number node
		const makePageNum = (num) => {
			let pageNum;
			if (num === this.query.page) {
				pageNum = document.createElement('span');
				pageNum.classList.add('current');

			} else {
				pageNum = document.createElement('a');
				// first page link
				if (num <= this.query.page - 3) {
					pageNum.classList.add('first');
				}
				// last page link
				if (num >= this.query.page + 3) {
					pageNum.classList.add('last');
				}
			}
			pageNum.classList.add('page-numbers');
			pageNum.dataset.page = num;
			pageNum.appendChild(document.createTextNode(num));
			return pageNum;
		}

		// only go 2 pages back from the current page
		const minPage = Math.max(1, this.query.page - 2);

		// only go 2 pages past the current page
		const maxPage = Math.min(totalPages, this.query.page + 2);

		// create first page number
		if (this.query.page >= 4) {
			this._paginationNumbers.push(makePageNum(1));
		}

		// create previous page numbers
		for (let i = minPage; i < this.query.page; i++) {
			this._paginationNumbers.push(makePageNum(i));
		}
		// create current page number
		this._paginationNumbers.push(makePageNum(this.query.page));

		// create next page numbers
		for (let i = this.query.page + 1; i <= maxPage; i++) {
			this._paginationNumbers.push(makePageNum(i));
		}

		// create last page number
		if (this.query.page <= (totalPages - 3)) {
			this._paginationNumbers.push(makePageNum(totalPages));
		}

		// append all page numbers to pagination
		this._paginationNumbers.forEach((num) => {
			this._pagination.appendChild(num);
		});

		// add ellipses to first or last links
		let firstPageLink = this._pagination.querySelector('.first');
		firstPageLink ? firstPageLink.insertAdjacentHTML('afterend', '<span class="page-numbers dots">…</span>') : false;

		let lastPageLink = this._pagination.querySelector('.last');
		lastPageLink ? lastPageLink.insertAdjacentHTML('beforebegin', '<span class="page-numbers dots">…</span>') : false;

		// re-show our pagination
		if (this._pagination.hidden) {
			this._pagination.removeAttribute('hidden');
		}
	}
}

export default SearchFilter;
